import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

const BaseSwal = withReactContent(Swal);

const defaultOptions = {
  buttonsStyling: false,
  showCloseButton: true,
  customClass: {
    confirmButton: 'btn btn-primary btn-lg',
    cancelButton: 'btn btn-default btn-lg',
    actions: 'text-center',
  },
};

export const ReactSwal = {
  fire: (options) => BaseSwal.fire({ ...defaultOptions, ...options }),
  close: () => BaseSwal.close(),
  showValidationMessage: (message) => BaseSwal.showValidationMessage(message),
};

export const confirmationModal = (type, title, text, html, timer) => {
  ReactSwal.fire({
    type,
    title,
    text,
    html,
    timer,
    allowOutsideClick: true,
    showCancelButton: false,
    showConfirmButton: false,
    showCloseButton: true,
  });
};

export const displayErrorModal = ({
  title = 'Oops...',
  text = 'Something went wrong, please try again.',
  html,
  timer,
} = {}) => ReactSwal.fire({
  type: 'error',
  title,
  text,
  html,
  timer,
  allowOutsideClick: true,
  showCancelButton: false,
  showConfirmButton: true,
  showCloseButton: true,
});

export const displaySuccessModal = ({
  title = 'Success',
  html,
  text,
  timer,
  icon = 'success',
} = {}) => ReactSwal.fire({
  type: icon,
  title,
  text,
  html,
  timer,
  allowOutsideClick: true,
  showCancelButton: false,
  showConfirmButton: true,
  showCloseButton: true,
});

export const confirmationDialog = ({
  title = 'Confirm',
  text = 'Are you sure?',
  html,
  confirmButtonText = 'Yes',
  cancelButtonText = 'No',
} = {}) => ReactSwal.fire({
  title,
  text,
  html,
  type: 'question',
  showCancelButton: true,
  confirmButtonText,
  cancelButtonText,
});
